import store from '@/states/index.js'

import ProjectPlanner from '../ProjectPlanner.vue'

export default [
    {
        path: '/template_project_planner',
        component: ProjectPlanner,
        name: 'template_project_planner',
        beforeEnter: (to, from, next) => {
            const role = store.getters['auth/getuser']
            if(role.info.role === 1){
                next()
            }else{
                next('/')
            }
            return
        }
    }
]